import React from 'react';
import { Link } from 'react-router-dom'
import moment from 'moment'
function ChannelingCard({ channel }) {
    return (
        <>

            <div className='column is-one-third-desktop is-5-tablet is-8-mobile main-card'>
                <div className='columns top-col'>
                    <div className='column is-12 top-col'>
                        <Link to={`/viewchanneling/${channel._id}`}>
                            <div className='box single-card top-card'>
                                <div className='columns is-justify-content-center is-mobile'>
                                    <div className='column is-2-desktop is-4-tablet is-4-mobile'>
                                        <i className="fas fa-stethoscope ic"></i>
                                    </div>
                                    <div className='column is-8-desktop is-6-tablet is-8-mobile'>
                                        <h1 className='ml-5 date'>{moment(channel.date).format("DD-MM-YYYY")}</h1>
                                    </div>
                                </div>

                            </div>
                        </Link>
                    </div>
                </div>
                <div className='columns'>
                    <div className='column is-12 bot-col'>
                        <Link to={`/viewchanneling/${channel._id}`}>
                            <div className='box bot-card'>
                                <h1 className='title has-text-centered mb-3 is-5'>{channel.reason}</h1>
                                <div className='columns is-gapless is-justify-content-center is-mobile'>
                                    <div className='column is-5'>

                                        <h1><i className="far fa-clock mr-1"></i>{channel.time}</h1>
                                    </div>
                                    <div className='column is-7'>
                                        <h1><i className="fas fa-location mr-1"></i>{channel.visitCity}</h1>
                                    </div>
                                </div>
                            </div>
                        </Link>
                    </div>
                </div>

            </div >

        </>
    );
}

export default ChannelingCard;